// extracted by mini-css-extract-plugin
export var Hero = "r_x";
export var aniSpin = "r_d";
export var image = "r_t";
export var inner = "r_r";
export var slide = "r_z";
export var staticLayout = "r_B";
export var wipe = "r_y";